import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/10 bg-background py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-145" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-146" data-mp="2vp6c4b7o0i88">
        <div className="text-center" data-id="element-147" data-mp="39hcsnyeqcr87">
          <SectionHeading id="problem-title" data-id="element-148" data-mp="39gb4cs8pe88j">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-foreground" data-id="element-149" data-mp="35fiv3yzu03c9">
            You're working on solar installations but struggle with gaps in technical understanding. When clients ask
            about system sizing or performance issues, you can't confidently explain the technical reasons.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/25 bg-surface p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-150" data-mp="1p3vo1w8a88gu">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-foreground" data-id="element-151" data-mp="sd0585nwoacz">
            <AlertTriangleIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-152" data-mp="x5jrrs4kmftx" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-153" data-mp="123czwqpfpjwu">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-154" data-mp="171mxf7ymswlm">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-primary" aria-hidden="true" data-id="element-155" data-mp="1c1j0n4zi8k04" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-156" data-mp="3dtnoa49z0v51">
          <p className="text-lg font-bold text-foreground" data-id="element-157" data-mp="3duqesb3dsvkf">
            Stop guessing.
          </p>
          <p className="mt-3 text-3xl font-bold tracking-tight text-accent sm:text-4xl" data-id="element-158" data-mp="3hv9520pmltki">Build your professional solar knowledge today.</p>
        </div>
      </div>
    </section>;
}